import React, { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {},
  button: {
    // backgroundImage: "linear-gradient(180deg, #0C4DA2 0%, #0C4DA2 100%)",
    textAlign: "center",
    color: "white !important",
    fontSize: "12px",
    width: "130px",
    borderRadius: "10px",
    height: "30px",
    boxShadow: "0px 3.81px 3.81px 0px rgba(0, 0, 0, 0.25)",
    display: "block",
    margin: "10px auto",
  },
  radioGroup: {
    display: "flex",
    flexDirection: "column",
  },
  formControlLabel: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    backgroundColor: "#eef2f7",
    borderRadius: "10px",
    border: "1px solid #ccc",
    marginRight: "25px",
    marginLeft: "25px",
    flexWrap: "wrap",
    justifyContent: "center",
  },
  accountLabel: {
    color: "#333",
    fontWeight: "500",
    whiteSpace: "nowrap",
  },
  radio: {
    marginLeft: "20px",
  },
  selectedMessage: {
    color: "green",
    textAlign: "center",
    fontSize: "14px",
    marginBottom: "10px",
    fontWeight: "600",
  },
}));

const maskAccountNumber = (accountNumber) => {
  const length = accountNumber.length;
  const maskedPart = "*".repeat(length - 4);
  const lastFourDigits = accountNumber.slice(-4);
  return maskedPart + lastFourDigits;
};

export default function AccountList(props) {
  const classes = useStyles();
  const [value, setValue] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const [buttonSubmitted, setButtonSubmitted] = useState(false); // New state for button color


  let accountNo = [];
  let resultset = null;
  let type = null;

  props.accountListData.forEach((item) => {
    type = typeof item.Body.Payload.ResultSet;

    if (type === "object") {
      accountNo = item.Body.Payload.ResultSet.AccountNo;
    } else if (type === "string") {
      resultset = item.Body.Payload.ResultSet;
    }
  });

  useEffect(() => {
    if (accountNo.length === 1) {
      const singleAccount = accountNo[0];
      setValue(singleAccount);
      props.onSendWorkflowAccountList(singleAccount);
      setIsDisabled(true);
    }
  }, [accountNo, props]);

  const handleRadioChange = (e) => {
    setValue(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (value) {
      props.onSendWorkflowAccountList(value);
      setIsDisabled(true);
      setButtonSubmitted(true);
    }
  };

  return (
    <>
      {type === "object" ? (
        <div
          className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70"
          style={{
            border: "8px solid rgba(244, 176, 53, 0.8)",
            backgroundColor: "rgba(245, 243, 243, 1)",
            marginLeft: "10px",

          }}
        >
          {accountNo.length === 1 ? (
            <div className={classes.selectedMessage}>
              Account <strong>{maskAccountNumber(accountNo[0])}</strong> is
              selected 
            </div>
          ) : (
            <form
              onSubmit={handleSubmit}
              style={{ backgroundColor: "rgba(245, 243, 243, 1)" }}
            >
              <Grid item xs>
                <FormControl component="fieldset" className={classes.formControl}>
                  <FormLabel
                    component="legend"
                    style={{
                      color: "rgba(12, 77, 162, 1)",
                      fontSize: "18px",
                      textAlign: "center",
                      fontWeight: "600",
                      marginTop: "5px",
                    }}
                  >
                    {props.language === "hn"
                      ? "खाता सूची"
                      : props.language === "od"
                      ? "ଖାତା ତାଲିକା"
                      : "Account List"}
                  </FormLabel>
                  <p
                    style={{
                      fontSize: "12px",
                      textAlign: "center",
                      marginTop: "6px",
                    }}
                  >
                    Please select your account number
                  </p>
                  <RadioGroup
                    aria-label="account-list"
                    name="account-list"
                    value={value}
                    onChange={handleRadioChange}
                    className={classes.radioGroup}
                  >
                    {accountNo.map((acc_num, i) => (
                      <FormControlLabel
                        key={i}
                        value={acc_num}
                        disabled={isDisabled}
                        control={<Radio className={classes.radio} />}
                        label={
                          <span className={classes.accountLabel}>
                            {maskAccountNumber(acc_num)}
                          </span>
                        }
                        className={classes.formControlLabel}
                        labelPlacement="start"
                      />
                    ))}
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Button
                type="submit"
                variant="outlined"
                style={{backgroundColor: buttonSubmitted ? 'grey' : 'rgba(12, 77, 162, 1)'}}

                className={classes.button}
                disabled={!value || isDisabled}
              >
                Submit
              </Button>
            </form>
          )}
        </div>
      ) : (
        props.accountListNoData(resultset)
      )}
    </>
  );
}
